import { render, staticRenderFns } from "./QAMultipleItems.vue?vue&type=template&id=36fad6a5&scoped=true&"
import script from "./QAMultipleItems.vue?vue&type=script&lang=js&"
export * from "./QAMultipleItems.vue?vue&type=script&lang=js&"
import style0 from "./QAMultipleItems.vue?vue&type=style&index=0&id=36fad6a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fad6a5",
  null
  
)

export default component.exports